// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"1ecc145c","272":"141b2dbc","379":"b4cee2c7","444":"263f2996","643":"0b7e88ef","869":"07a7a607","877":"c420fb51","918":"0691b375"}[chunkId] + ".chunk.js";
};